<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>数据验证</span>
          <el-button v-permisaction="['config:slotTest:add']" type="primary" size="mini" style="margin-left: 16px;" @click="edit(formDataBak)">新增</el-button>
        </div>

        <template>
          <el-table
            :data="tableData"
            border
            style="width: 100%"
          >
            <el-table-column
              prop="group"
              label="组名"
              width="150px"
              align="center"
            />
            <el-table-column
              prop="test_user_count"
              label="用户数"
              align="center"
              width="80px"
            />
            <el-table-column
              prop="init_level"
              label="初始等级"
              width="80px"
              align="center"
            />
            <el-table-column
              prop="init_spin"
              label="初始体力"
              align="center"
              width="80px"
            />

            <el-table-column
              prop="new_daily_spin"
              label="每日新增体力"
              align="center"
              width="100px"
            />
            <el-table-column
              prop="avg_time"
              label="平均在线"
              align="center"
              width="80px"
            />
            <el-table-column
              prop="login_day"
              label="登录天数"
              width="80px"
              align="center"
            />
            <el-table-column
              prop="test_act"
              label="测试功能"
              width="200px"
              align="center"
              :formatter="actFormatter"
            />
            <el-table-column
              prop="out"
              label="输出数据"
              align="center"
              :formatter="outFormatter"
              width="200px"
            />
            <el-table-column
              prop="run_times"
              label="运行次数"
              align="center"
            />
            <el-table-column
              prop="run"
              label="已运行次数"
              align="center"
            />
            <el-table-column
              prop="status"
              label="状态"
              align="center"
              :formatter="statusFormatter"
            />
            <el-table-column
              fixed="right"
              label="操作"
              width="240px"
            >
              <template v-slot:default="scope">
                <el-button v-permisaction="['config:slotTest:add']" type="text" size="small" @click="edit(scope.row)">编辑</el-button>
                <el-button v-if="scope.row.status === 0" v-permisaction="['config:slotTest:add']" type="text" size="small" @click="start(scope.row.id,1)">启动</el-button>
                <el-button v-if="scope.row.status === 1" v-permisaction="['config:slotTest:add']" type="text" size="small" @click="start(scope.row.id,2)">停止</el-button>
                <el-button v-permisaction="['config:slotTest:add']" type="text" size="small" @click="copy(scope.row.id)">拷贝</el-button>
                <el-button v-if="scope.row.status !== 0" v-permisaction="['config:slotTest:view']" type="text" size="small" @click="view(scope.row.id)">运行结果</el-button>
                <el-button v-if="scope.row.status !== 0" v-permisaction="['config:slotTest:view']" type="text" size="small" @click="stat(scope.row.id)">心情数据</el-button>
                <el-link v-if="scope.row.status !== 1" v-permisaction="['config:slotTest:copy']" :underline="false" style="margin-left: 5px" type="danger" size="small" @click="del(scope.row.id)">删除</el-link>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            v-show="total>0"
            background
            :page.sync="queryParams.pageIndex"
            :limit.sync="queryParams.pageSize"
            :total="total"
            @pagination="getTables"
          />
        </template>
      </el-card>

      <el-drawer
        title="配置"
        :visible.sync="drawer"
        size="800px"
        :before-close="handleClose"
      >
        <el-form ref="formData" :rules="rules" :model="formData" label-width="120px">
          <el-form-item label="测试组名" prop="group" style="width: 400px;">
            <el-input v-model="formData.group" placeholder="测试组名" />
          </el-form-item>
          <el-form-item label="心情配置" prop="slot_config_id" style="width: 400px;">
            <el-select v-model="formData.slot_config_id" style="width: 400px" placeholder="请选择">
              <el-option
                v-for="item in SlotMood"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="测试用户数" prop="test_user_count" style="width: 400px;">
            <el-input v-model.number="formData.test_user_count" :readonly="formData.status > 0" />
          </el-form-item>
          <el-form-item label="初始等级" prop="init_level" style="width: 400px;">
            <el-input v-model.number="formData.init_level" :readonly="formData.status > 0" />
          </el-form-item>
          <el-form-item label="初始体力" prop="init_spin" style="width: 400px;">
            <el-input v-model.number="formData.init_spin" :readonly="formData.status > 0" />
          </el-form-item>
          <el-form-item label="每日新增体力" prop="new_daily_spin" style="width: 400px;">
            <el-input v-model.number="formData.new_daily_spin" />
          </el-form-item>
          <el-form-item label="平均在线" prop="avg_time" style="width: 400px;">
            <el-input v-model.number="formData.avg_time" :readonly="formData.status > 0" />
          </el-form-item>
          <el-form-item label="登录天数" prop="login_day" style="width: 400px;">
            <el-input v-model.number="formData.login_day" :readonly="formData.status > 0" />
          </el-form-item>
          <el-form-item label="选择测试功能" prop="test_act" style="width: 400px">
            <el-select v-model="formData.test_act" style="width: 400px" multiple placeholder="请选择">
              <el-option
                v-for="item in testAct"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="输出配置" prop="out" style="width: 400px">
            <el-select v-model="formData.out" style="width: 400px" multiple placeholder="请选择">
              <el-option
                v-for="item in outAct"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="运行次数" prop="run_times" style="width: 400px;">
            <el-input v-model.number="formData.run_times" />
          </el-form-item>
          <el-form-item style="width:100%;margin-top:50px;text-align: center">
            <el-button type="primary" @click="onSubmit()">保存</el-button>
          </el-form-item>
        </el-form>
      </el-drawer>

      <el-drawer
        title="用户数据"
        :visible.sync="drawerUser"
        :with-header="false"
        size="800px"
      >
        <template>
          <el-table
            :data="tableUserData"
            border
            style="width: 100%"
          >
            <el-table-column
              prop="uid"
              label="用户ID"
              width="180"
            />
            <el-table-column
              prop="level"
              label="建筑等级"
              width="180"
            />
            <el-table-column
              prop="spins"
              label="消耗体力"
              width="180"
            />
            <el-table-column
              prop="coin"
              label="消耗金币"
            />
          </el-table>
        </template>
      </el-drawer>

    </template>
  </BasicLayout>
</template>

<script>
import { getRewardType } from '@/api/config/slot'
import {
  copySlotTest,
  delSlotTestList, getSlotTestAllList,
  getSlotTestList,
  startSlotTest,
  updateSlotTestCfg,
  viewSlotTest
} from '@/api/config/slot-test'

export default {
  name: 'SlotTest',
  data() {
    return {
      SlotMood: [],
      testAct: [
        { label: '棋盘走格子', value: 1 },
        { label: '建造', value: 2 }
        // { label: '收集活动', value: 3 },
        // { label: '锦标赛活动', value: 4 }
      ],
      outAct: [
        { label: '消耗体力', value: 1 },
        { label: '消耗金币', value: 2 },
        { label: '玩家等级', value: 3 }
      ],
      total: 0,
      tableData: [],
      loading: false,
      drawer: false,
      drawerUser: false,
      drawerCfg: false,
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      tableUserData: [],
      formDataBak: {
        id: 0,
        slot_config_id: '',
        group: '',
        test_user_count: 1,
        init_level: 1,
        init_spin: 1,
        new_daily_spin: 1,
        avg_time: 0,
        login_day: 0,
        test_act: [],
        out: [],
        run_times: 1,
        status: 0
      },
      formData: {
        id: 0,
        slot_config_id: '',
        group: '',
        test_user_count: 0,
        init_level: 0,
        init_spin: 0,
        new_daily_spin: 0,
        avg_time: 0,
        login_day: 0,
        test_act: [],
        out: [],
        run_times: 1,
        status: 0
      },
      rules: {
        group: [
          { required: true, message: '请输入用户分组', trigger: 'blur' }
        ],
        slot_config_id: [
          { required: true, message: '请选择心情配置', trigger: 'blur' }
        ],
        test_user_count: [
          { required: true, message: '请输入测试用户数', trigger: 'blur' }
        ],
        init_level: [
          { required: true, message: '请输入初始等级', trigger: 'blur' }
        ],
        init_spin: [
          { required: true, message: '请输入初始体力', trigger: 'blur' }
        ],
        new_daily_spin: [
          { required: true, message: '请输入每日新增体力', trigger: 'blur' }
        ],
        avg_time: [
          { required: true, message: '请输入平均在线', trigger: 'blur' }
        ],
        login_day: [
          { required: true, message: '请输入登录天数', trigger: 'blur' }
        ],
        test_act: [
          { required: true, message: '请选择测试功能', trigger: 'blur' }
        ],
        out: [
          { required: true, message: '请选择输出配置', trigger: 'blur' }
        ],
        run_times: [
          { required: true, message: '请输入运行天数', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.getTables()
    this.getSlotTestCfg()
  },
  methods: {
    handleClose(d) {
      this.drawer = false
    },
    getRewardTypeData() {
      getRewardType().then(res => {
        if (res.code === 200) {
          this.rewardTypes = res.data
        }
      })
    },
    copy(id) {
      copySlotTest({ id: id }).then(res => {
        if (res.code === 200) {
          this.getTables()
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    stat(id) {
      this.$router.push({ name: 'SlotTestStat', query: { id: id }})
    },
    edit(row) {
      this.formData = row
      this.drawer = true
    },
    onSubmit() {
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          const _data = this.formData
          if (_data.test_user_count <= 0) {
            this.msgError('测试用户数至少需要1个')
            return
          }
          if (_data.init_level <= 0) {
            this.msgError('初始等级不能小于0')
            return
          }
          if (_data.init_spin <= 0) {
            this.msgError('初始体力不能小于0')
            return
          }
          if (!_data.run_times) {
            this.msgError('运行次数不能小于0')
            return
          }

          const data = JSON.stringify(this.formData)
          updateSlotTestCfg({ data: data }).then(res => {
            if (res.code === 200) {
              this.drawer = false
              this.formData = this.formDataBak
              this.msgSuccess(res.msg)
              this.getTables()
            } else {
              this.msgError(res.msg)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getSlotTestCfg() {
      getSlotTestAllList().then(res => {
        if (res.code === 200) {
          res.data.forEach(item => {
            this.SlotMood.push({ label: item.name, value: item.id })
          })
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      this.loading = true
      getSlotTestList(this.queryParams).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data.list
          this.total = res.data.count
        } else {
          this.msgError(res.msg)
        }
      })
    },
    add() {
      this.drawer = true
    },
    del(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delSlotTestList({ id: id }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables()
          } else {
            this.msgError(res.msg)
          }
        })
      })
    },
    actFormatter(row, col, val) {
      const text = []
      for (const i in val) {
        const v = val[i]
        for (const k in this.testAct) {
          const act = this.testAct[k]
          if (act.value === v) {
            text.push(act.label)
          }
        }
      }
      return text.join(',')
    },
    outFormatter(row, col, val) {
      const text = []
      for (const i in val) {
        const v = val[i]
        for (const k in this.outAct) {
          const act = this.outAct[k]
          if (act.value === v) {
            text.push(act.label)
          }
        }
      }
      return text.join(',')
    },
    statusFormatter(row, col, val) {
      let text = ''
      const status = parseInt(val)
      switch (status) {
        case 0:
          text = '未运行'
          break
        case 1:
          text = '运行中'
          break
        case 2:
          text = '已停止'
          break
        case 3:
          text = '结算中'
          break
        case 4:
          text = '已完成'
          break
      }
      return text
    },
    start(id, sttaus) {
      startSlotTest({ id: id, data: sttaus }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    view(id) {
      this.drawerUser = true
      viewSlotTest({ id: id }).then(res => {
        if (res.code === 200) {
          this.tableUserData = res.data
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
